import * as React from 'react';
// @ts-ignore
import { createPortal } from 'react-dom';

import { format } from 'date-fns';
import { get } from 'lodash';
import { ListBox } from 'primereact/listbox';
import { Timeline } from 'primereact/timeline';
import { Card } from 'primereact/card';
import { Divider } from 'primereact/divider';
import { Button } from 'primereact/button';
import {
  getUserCertificates,
  Certificate,
  createDetachedSignature,
  createHash,
  getSystemInfo,
} from '../crypto-pro-module/crypto-pro';
import parse from 'html-react-parser';
import * as sanitizeHtml from 'sanitize-html';

import Field from '../../components/Field';
import ErrorAlert from '../../components/ErrorAlert';

import { Component, createFile, Guid, replacer } from '../../../helpers/Utils';

import ApiClientModule from '../../../../services/ApiClientModule';
import MultipleFiles from '../../MultipleFiles';
import { createCheckbox } from '../../Checkbox';

// TODO: Need refactoring and types

export class SigCreatorFromFileDefault extends Component<any, any> {
  state = {
    signed: false,
    certificates: null,
    certificate: null,
    status: [],
    files: {
      pdf: null,
      sig: null,
    },
    shouldResetFiles: false,
    portalElem: null,
  };

  constructor(props) {
    super(props);
    this.getError = this.getError.bind(this);
    this.handlerChangeCertificate = this.handlerChangeCertificate.bind(this);
    this.pushState = this.pushState.bind(this);
    this.signFile = this.signFile.bind(this);
    this.getPdfFile = this.getPdfFile.bind(this);
    this.getCertificates = this.getCertificates.bind(this);
    this.handlerChangeCertificate = this.handlerChangeCertificate.bind(this);
    this.setError = this.setError.bind(this);
  }

  async componentDidMount() {
    const { dispatcher, schema } = this.props;
    await this.getCertificates();
    dispatcher.controlVisited(schema.id);

    const pdf = dispatcher.pullValue(`${schema.id}_file`);
    const sig = dispatcher.pullValue(`${schema.id}_sig`);

    if (schema.shouldResetFilesAfterRefresh && (!pdf || !sig)) {
      this.setState({ shouldResetFiles: true });
    } else {
      this.setState({
        signed: pdf && sig ? true : false,
        files: {
          pdf,
          sig,
        },
      });
    }

    // Если файлы уже лежат, значит подпись происходила, и все шаги надо отобразить
    if (dispatcher.pullValue(`${schema.id}_sig`)) {
      this.setState({
        status: [
          {
            message: 'Загрузка сертификатов',
            loading: false,
          },
          {
            message: 'Выбор сертификата',
            loading: false,
          },
          {
            message: 'Получение файла',
            loading: false,
          },
          {
            message: 'Подпись файла',
            loading: false,
          },
        ],
      });
    }

    this.setState({
      portalElem: document.getElementById('sigCreatorWrapper'),
    });
  }

  componentDidUpdate(
    prevProps: Readonly<any>,
    prevState: Readonly<any>,
    snapshot?: any,
  ): void {
    const { shouldResetFiles } = this.state;

    if (shouldResetFiles) {
      this.setState(({ certificate }) => ({
        // убирается свойство для ресета дочерних компонентов файлов
        shouldResetFiles: false,
        // ресетится состояние к старту заполнения
        signed: false,
        files: {
          sig: undefined,
          pdf: undefined,
        },
        status: [
          { message: 'Загрузка сертификатов', loading: false },
          { message: 'Выбор сертификата', loading: !certificate },
        ],
      }));
    }
  }

  getError = () => {
    const { error, visited, value } = this.props;
    const errorText = visited && error?.message;

    let className = 'default';
    if (value && !errorText) {
      className = 'success';
    } else if (errorText) {
      className = 'error';
    }

    return {
      className,
      errorText,
    };
  };

  setError(title, message) {
    this.props.dispatcher.setError(
      this.props.schema.id,
      undefined,
      {
        message: title,
      },
      true,
    );
    this.props.dispatcher.notify(message);
  }

  /*
   * Подписывает файлы в base64, возвращает подпись файлом или текстом
   * */

  /*
   * Возвращает список сертификатов
   * */
  getCertificates = async () => {
    let certificates: Certificate[] | any;
    this.pushState({
      message: 'Загрузка сертификатов',
      loading: true,
    });

    try {
      await getSystemInfo();
      try {
        certificates = await getUserCertificates();
        // eslint-disable-next-line guard-for-in
        for (const key in certificates) {
          // eslint-disable-next-line no-await-in-loop
          certificates[key].extra = await certificates[key].getOwnerInfo();
        }

        this.pushState(
          {
            message: 'Загрузка сертификатов',
            loading: false,
          },
          {
            certificates,
          },
        );
        this.pushState({
          message: 'Выбор сертификата',
          loading: true,
        });
      } catch (error) {
        this.setError(
          'В системе не нашлись сертификаты',
          <p>{error.message || 'В системе не нашлись сертификаты'}</p>,
        );
      }
    } catch (error) {
      this.setError(
        'Не установлен плагин',
        <>
          <p>Не установлен плагин</p>
          <p>
            Инструкцию по установке и настройке плагина можно получить по
            адресу:&nbsp;
            <a
              href="https://www.cryptopro.ru/products/cades/plugin"
              target="_blank"
            >
              https://www.cryptopro.ru/products/cades/plugin
            </a>
          </p>
        </>,
      );
    }
  };

  /*
   * Обработчик выбора сертификата
   * */
  handlerChangeCertificate = e => {
    const { certificates } = this.state;
    const certificate = certificates.find(item => item.thumbprint === e.value);

    this.pushState(
      {
        message: 'Выбор сертификата',
        loading: false,
      },
      {
        certificate,
      },
    );
  };

  /**
   * Получение имени для создания файлов
   */
  getDefaultFilename(): string {
    return this.props.schema?.extra?.defaultFilename || 'file';
  }

  /*
   * Получение файла
   * */
  async getPdfFile(): Promise<any> {
    const { fileLocationUrl } = this.props.schema;
    const { certificates } = this.state;

    if (!certificates?.length) {
      await this.getCertificates();
    }

    return new Promise((resolve, reject) => {
      try {
        // Инициирую api
        // Создаю строку с URL откуда забирать файл
        this.pushState(
          {
            message: 'Получение файла',
            loading: true,
          },
          {
            files: {
              pdf: null,
              sig: null,
            },
          },
        );

        const apiClientModule = new ApiClientModule();
        const sourceObject = Object.keys(fileLocationUrl.pathFromProps).reduce(
          (acc, index) => {
            const item = fileLocationUrl.pathFromProps[index];
            return {
              ...acc,
              [index]: get(this.props, item),
            };
          },
          {},
        );
        const result = replacer(fileLocationUrl.url, sourceObject);

        // Пытаюсь забрать файл
        apiClientModule.getFileArrayBuffer(
          result,
          {},
          {
            success: async response => {
              const arrayBuffer = response.data;
              const base64 = `data:application/pdf;base64,${Buffer.from(
                arrayBuffer,
              ).toString('base64')}`;

              this.pushState(
                {
                  message: 'Получение файла',
                  loading: false,
                },
                {
                  files: {
                    ...this.state.files,
                    pdf: {
                      id: Guid.newGuid(),
                      url: base64,
                      value: `${this.getDefaultFilename()}.pdf`,
                      isLoader: false,
                      isBase64: true,
                      arrayBuffer,
                    },
                  },
                },
              );

              resolve({
                id: Guid.newGuid(),
                url: base64,
                value: `${this.getDefaultFilename()}.pdf`,
                isLoader: false,
                isBase64: true,
                arrayBuffer,
              });

              return response;
            },
            error: ({ response }) => {
              /* if(!response?.data?.pd_field_errors) {
                            this.setError('Не удалось получить подписываемый файл', <>
                                <p>Не удалось получить подписываемый файл</p>
                            </>);
                        }*/
              const json = JSON.parse(
                String.fromCharCode.apply(null, new Uint8Array(response.data)),
              );
              this.props.dispatcher.setErrors(json.field_errors);
              reject(json.field_errors);
            },
          },
        );
      } catch (error) {
        this.setError('Ошибка получения файла', <p>Ошибка получения файла</p>);
        reject(error);
      }
    });
  }

  pushState = async (
    data: { message: string; loading: boolean },
    state = {},
  ) => {
    const foundStatusIndex = this.state.status.findIndex(
      item => item.message === data.message,
    );
    if (foundStatusIndex >= 0) {
      this.setState(({ status }) => ({
        status: status.map((item, index) => {
          if (index === foundStatusIndex) {
            return data;
          }
          return item;
        }),
        ...state,
      }));
    } else {
      this.setState(({ status }) => ({
        status: [...status, data],
        ...state,
      }));
    }

    return Promise.resolve();
  };

  customDeleteFile = (type: 'pdf' | 'sig') => async () => {
    const { certificates, shouldResetFiles } = this.state;

    /**
     *  при ресете файлов произойдет несколько вызовов этого метода,
     *  мы хотим менять стейт не в середине процесса,
     *  а после завершения ресета полей
     */
    if (shouldResetFiles) return;

    this.setState({ signed: false });

    this.setState(({ files, certificate }) => {
      const _files =
        type === 'pdf'
          ? {
              sig: undefined,
              pdf: undefined,
            }
          : {
              ...files,
              sig: undefined,
            };

      const _status = [{ message: 'Загрузка сертификатов', loading: false }];

      if (type === 'pdf') {
        _status.push({ message: 'Выбор сертификата', loading: !certificate });
      } else {
        _status.push(
          { message: 'Выбор сертификата', loading: false },
          { message: 'Получение файла', loading: false },
        );
      }

      return {
        files: _files,
        status: _status,
      };
    });

    if (!certificates) {
      await this.getCertificates();
    }
  };

  updateSigWithOldPdf = async arrayBuffer => {
    const { certificate } = this.state;
    const hash = await createHash(arrayBuffer);
    const sign = await createDetachedSignature(certificate.thumbprint, hash);

    this.pushState(
      {
        message: 'Подпись файла',
        loading: false,
      },
      {
        signed: true,
        files: {
          ...this.state.files,
          sig: {
            id: Guid.newGuid(),
            url: createFile(sign),
            value: `${this.getDefaultFilename()}.sig`,
            isLoader: false,
            isBase64: true,
          },
        },
      },
    ).then(() => {
      this.props.dispatcher.setError(
        this.props.schema.id,
        undefined,
        undefined,
        undefined,
      );
      this.props.dispatcher.notify('Файл успешно подписан');

      if (this.props.schema?.extra?.isRefreshForm) {
        setTimeout(() => {
          this.props.dispatcher.onUpdateForm(this.props.schema.id);
        }, 1000);
      }
    });
  };

  async signFile() {
    const {
      certificate,
      files: {
        pdf: { arrayBuffer },
      },
    } = this.state;

    this.pushState({
      message: 'Подпись файла',
      loading: true,
    });

    if (!certificate?.thumbprint) {
      this.setError(
        'Ошибка при подписании файла',
        <p style={{ whiteSpace: 'pre' }}>Выберите сертификат</p>,
      );

      return;
    }

    try {
      if (!arrayBuffer) {
        const {
          files: { pdf },
        } = this.state;
        const apiModule = new ApiClientModule();

        await apiModule.getFileByUrl(pdf.inputs?.[0].url, 'arraybuffer', {
          success: async ({ data }) => {
            await this.updateSigWithOldPdf(data);

            return data;
          },
        });
      } else {
        await this.updateSigWithOldPdf(arrayBuffer);
      }
    } catch (error) {
      let message = '';

      if (certificate === null) {
        message = 'Не выбран сертификат';
      } else if (error.message) {
        message = `${error.message}\n\nДля подробной информации обратитесь к разработчику`;
      } else {
        message = 'Ошибка при подписании файла';
      }
      this.setState({ signed: false });
      this.setError(
        'Ошибка при подписании файла',
        <p style={{ whiteSpace: 'pre' }}>{message}</p>,
      );
    }
  }

  createFileInput({
    someProperties,
    ...schemaProps
  }: {
    title: { ru: string; en: string };
    id: string;
    value: any;
    disabled: boolean;
    activeDeleteBtn: boolean;
    someProperties?: Record<string, any>;
  }) {
    const { schema, api, dispatcher, error } = this.props;

    return (
      <MultipleFiles
        schema={{
          ...schema,
          ...schemaProps,
        }}
        api={api}
        dispatcher={dispatcher}
        error={error}
        someProperties={{
          shouldReset: this.state.shouldResetFiles,
          ...someProperties,
        }}
      />
    );
  }

  public render() {
    const {
      schema,
      api,
      dispatcher,
      error,
      opts: { rowSection },
    } = this.props;
    const {
      certificates,
      certificate,
      status,
      signed,
      files: { pdf, sig },
    } = this.state;
    const { className, errorText } = this.getError();

    let elemsForPortal;
    // Забираем из контролов те, которые нам нужно прокинуть через портал
    if (schema.elementsForPortal) {
      elemsForPortal = rowSection.controls.filter(control => {
        return schema.elementsForPortal?.includes(control.id);
      });
    }

    return (
      <>
        {schema.subtitle && (
          <div style={{ textDecoration: 'underline', color: '#00008b' }}>
            {parse(sanitizeHtml(schema.subtitle))}
          </div>
        )}
        <Field {...this.props.schema} status={className}>
          <div className="sigCreatorWrapper" id="sigCreatorWrapper">
            <div className="certificates">
              <p>Каким сертификатом подписать файл?</p>
              <div className="certificates__list">
                {/* TODO */}
                {/* @ts-ignore */}
                <ListBox
                  optionLabel="name"
                  optionValue="thumbprint"
                  options={certificates}
                  value={certificate?.thumbprint}
                  // disabled={schema.disabled}
                  itemTemplate={option => (
                    <div>
                      <h5>Сертификат {option.name}</h5>
                      <h6>
                        {option.extra[0].title}: {option.extra[0].description}
                      </h6>
                      <h6>
                        Действителен до:{' '}
                        {format(new Date(option.validTo), 'dd.MM.yyyy')}
                      </h6>
                    </div>
                  )}
                  onChange={this.handlerChangeCertificate}
                />
              </div>
            </div>

            {/* TODO */}
            {/* @ts-ignore */}
            <Divider />

            <div className="status">
              {/* TODO */}
              {/* @ts-ignore */}
              <Card className="status__list">
                {/* TODO */}
                {/* @ts-ignore */}
                <Timeline
                  value={status}
                  align="left"
                  content={item => item.message}
                  marker={item => (
                    <div
                      className="p-timeline-event-marker"
                      style={{
                        backgroundColor: item.loading ? '#f0ad4e' : '#5cb85c',
                        border: 'unset',
                      }}
                    />
                  )}
                />
              </Card>
            </div>

            {/* @ts-ignore */}
            <Divider />
            <div className="sig-file">
              {this.createFileInput({
                id: `${schema.id}_file`,
                value:
                  dispatcher.pullValue(`${schema.id}_file`) ??
                  (pdf ? { inputs: [pdf] } : null),
                title: schema.fileTitle?.pdf ?? {
                  ru: 'Файл для подписи',
                  en: 'Файл для подписи',
                },
                disabled: true,
                activeDeleteBtn:
                  schema.fileLocationUrl ||
                  !dispatcher.pullValue(`${schema.id}_sig`),
                someProperties: { customDelete: this.customDeleteFile('pdf') },
              })}
              {dispatcher.pullValue(`${schema.id}_file`)
                ? this.createFileInput({
                    id: `${schema.id}_sig`,
                    value:
                      dispatcher.pullValue(`${schema.id}_sig`) ??
                      (sig ? { inputs: [sig] } : null),
                    title: schema.fileTitle?.sig ?? {
                      ru: 'Открепленная подпись',
                      en: 'Открепленная подпись',
                    },
                    disabled: true,
                    activeDeleteBtn: true,
                    someProperties: {
                      customDelete: this.customDeleteFile('sig'),
                    },
                  })
                : null}
            </div>

            {/* @ts-ignore */}
            <Divider />
          </div>

          {/* Добавляем найденные контролы через портал в нужный нам дом элемент */}
          {this.state.portalElem &&
            elemsForPortal &&
            elemsForPortal.map(elem =>
              createPortal(
                // @ts-ignore
                createCheckbox(elem, api, dispatcher, error, false),
                this.state.portalElem,
              ),
            )}

          {dispatcher.pullValue(`${schema.id}_file`) ? (
            // @ts-ignore
            // TODO
            <Button
              label="Подписать"
              type="button"
              onClick={this.signFile}
              disabled={schema.disabled || signed}
            />
          ) : //@ts-ignore
          schema.fileLocationUrl ? (<Button
              label="Получить файл для подписи"
              type="button"
              onClick={this.getPdfFile}
              // disabled={schema.disabled}
            />
          ) : (
            <strong>
              Файл для подписи еще не был загружен в заявку, ожидайте
            </strong>
          )}
          <ErrorAlert errorMessage={errorText} />
        </Field>
      </>
    );
  }
}
